import React from "react";

const Pay = () => {
  return (
    <div>
      <p className="text-4xl"> Payment system coming soon</p>
    </div>
  );
};

export default Pay;
